// @ts-nocheck
import { Red_Hat_Display, Inter, Poppins } from "next/font/google";
import { createTheme } from "@mui/material/styles";

const interFont = Inter({
  weight: ["300", "400", "500", "700"],
  subsets: ["latin"],
  display: "swap",
});
const poppinsFont = Poppins({
  weight: ["300", "400", "500", "700"],
  subsets: ["latin"],
  display: "swap",
});
const redHatFont_old = Red_Hat_Display({
  weight: ["300", "400", "500", "700"],
  subsets: ["latin"],
  display: "swap",
});

const whiteColor = "#FFFFFF";
// const daFFFFFFColor = "#D5DDE5"; // light grey
const darkTextColor = "#FFFFFF"; // light grey
const darkTextColorSecondary = "#b1bbc6"; // dark grey
const darkButtonTextColor = "#FFFFFF";
const darkButtonBackgroundColor = "#3E7E71"; // muted green
const warningTextColor = "#FFDC5B"; // soft yellow
const warningTextColorLight = "#9f800d"; // soft yellow
// const darkBg = "#0C2D48" // navy blue
const darkBg = "#222c42"; // navy blue
const darkBgAccent = "#0a2338"; // navy blue
export const darkTheme = createTheme({
  palette: {
    black: {
      main: "#000",
    },
    grey: {
      main: "#cecece",
    },
    palette: {
      mode: "dark",
    },
  },
  typography: {
    // fontFamily: redHatFont.style.fontFamily,
    fontFamily: "inherit",
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,

    h1: {
      color: { darkTextColor },
      fontWeight: 700,
      fontSize: "2.125rem", // ~34px
      lineHeight: 1.2,
      marginBottom: "0.5rem",
      "@media (min-width:600px)": { fontSize: "2.5rem", lineHeight: 1.25 }, // 40px
    },
    h2: {
      color: `${darkTextColor}`,
      fontWeight: 600,
      // fontSize: "2rem", // ~28px
      fontSize: "1.8rem", // ~28px
      lineHeight: 1.25,
      marginBottom: "0.5rem",
      "@media (min-width:600px)": { fontSize: "2rem", lineHeight: 1.3 }, // 32px
      textAlign: "center",
    },
    h3: {
      color: `${darkTextColor} !important`,
      fontWeight: 400,
      fontSize: "1.375rem", // ~22px
      lineHeight: 1.3,
      marginBottom: "1.5rem",
      textAlign: "center",
      // padding: "0 30px",
      "@media (min-width:600px)": { fontSize: "1.375rem", lineHeight: 1.35 }, // 24px
    },
    h4: {
      color: darkTextColor,
      fontWeight: 600,
      fontSize: "1.25rem", // ~20px
      lineHeight: 1.35,
      marginBottom: "0.5rem",
      "@media (min-width:600px)": { fontSize: "1.375rem", lineHeight: 1.4 }, // 22px
    },
    h5: {
      color: darkTextColor,
      fontWeight: 700,
      fontSize: "1.125rem", // ~18px
      lineHeight: 1.4,
      marginBottom: "0.5rem",
      "@media (min-width:600px)": { fontSize: "1.25rem", lineHeight: 1.45 }, // 20px
    },
    h6: {
      color: `${darkTextColorSecondary}`,
      fontWeight: 400,
      fontSize: "1rem", // ~16px
      lineHeight: 1.5,
      marginBottom: "0.5rem",
      textAlign: "center",
      "@media (min-width:600px)": { fontSize: "1.125rem", lineHeight: 1.6 }, // 18px
    },

    subtitle1: {
      color: `${darkTextColor} !important`,
      fontWeight: 400,
      fontSize: "1rem", // ~17px (iOS) / 14px (macOS)
      lineHeight: 1.5,
      marginBottom: "0.5rem",
    },
    subtitle2: {
      fontWeight: 400,
      fontSize: "0.875rem", // ~14px
      lineHeight: 1.5,
      marginBottom: "0.5rem",
    },
    body1: {
      fontWeight: 400,
      fontSize: "1rem", // ~17px (iOS) / 14px (macOS)
      lineHeight: 1.6,
      marginBottom: "0.5rem",
      // color: `${darkTextColor} !important`,
    },
    body2: {
      fontWeight: 500,
      fontSize: "0.9375rem", // ~16px
      lineHeight: 1.6,
      marginBottom: "0.5rem",
    },
    attention: {
      color: `${warningTextColor} !important`,
      fontSize: "1rem !important", // ~17px (iOS) / 14px (macOS)
      textAlign: "justified",
    },
    caption: {
      fontWeight: 400,
      fontSize: "0.75rem", // ~12px
      lineHeight: 1.6,
      marginBottom: "0.5rem",
    },
    overline: {
      fontWeight: 500,
      fontSize: "0.6875rem", // ~11px
      lineHeight: 1.5,
      marginBottom: "0.5rem",
      textTransform: "none",
    },

    button: {
      fontWeight: 600,
      fontSize: "0.9375rem", // ~16px
      lineHeight: 1.4,
      marginBottom: "0.5rem",
      textTransform: "none",
      letterSpacing: "0.02em",
    },

    p: {
      color: `${darkTextColor} !important`,
      fontWeight: 400,
      fontSize: "1rem", // ~17px (iOS) / 14px (macOS)
      lineHeight: 1.5,
      marginBottom: "0.5rem",
    },

    disclaimer: {
      fontSize: "12px",
      textAlign: "justify",
      color: `${darkTextColor} !important`,
    },
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          background: `${darkBg} !important`,
          boxShadow: "none !important",

          "& .MuiBox-root": {
            background: `${darkBg} !important`,
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          backgroundColor: `${darkBgAccent}`,
          color: `${darkTextColor}`,
        },
      },
    },
    MuiBox: {
      styleOverrides: {
        root: {
          "& .suggestions-heading": {
            fontSize: "1rem", // Example: Change font size
            color: "#fff", // Example: Use your primary color
            fontWeight: "bold", // Example: Make it bold
            // Add any other CSS properties you want to control
          },
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: "#0C2D48",
        },
      },
    },
    MuiContainer: {
      styleOverrides: {
        root: {
          padding: 0,
          "& .postcode-container": {
            border: `1px solid ${darkTextColor}`,
          },

          "& .postcode-container--title": {
            background: `${darkBg}`,
            color: `${darkTextColor}`,
          },
          "& > .ping": {
            border: `1px solid ${darkBg}`,
          },
        },
      },
    },
    MuiTypography: {
      variants: [
        {
          props: { variant: "span" },
          style: {
            // fontSize: '1rem',
            // fontWeight: 400,
            // lineHeight: 1.5,
            // display: 'inline',
          },
        },
        {
          props: { variant: "heading" },
          style: {
            lineHeight: "46px",
            // maxWidth: "312px",
          },
        },
      ],
    },
    MuiTabs: {
      styleOverrides: {
        scroller: {
          borderRight: "none",
          padding: "20px",
          paddingBlockStart: 0,
          paddingInlineStart: "61px",
        },
        flexContainer: {
          borderLeft: "1px solid black",
          display: "flex",
          gap: "100px",
          height: "100%",
          paddingBlockStart: "40px",
        },
        indicator: {
          backgroundColor: "transparent",
          transform: "translateY(-10px)",
          left: "-5px",
          width: "50px",
          height: "50px",

          // "&::after": {
          //   content: '"\\1F693"',
          // },
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          // textTransform: "capitalize",
          fontWeight: 800,
          fontSize: "22px",
          alignItems: "flex-start",
          padding: "15px 24px",
          "&.Mui-selected": {
            color: "black",
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          backgroundColor: "#3E7E71",
          color: "#FFFFFF",
          display: "flex",
          fontSize: `18.75px`,
          textTransform: "none",
          fontWeight: 700,
          marginBottom: "30px",
          zIndex: 1,
          "&:hover": {
            background: "#54b29f",
            color: "#FFFFFF",
          },
          "&:active": {
            background: "#54b29f",
            color: "#FFFFFF",
          },
          "&:focus": {
            background: "#54b29f",
            color: "#FFFFFF",
          },
          "&.primary-button": {
            border: "1px solid black",
            borderRadius: "20px",
            color: "black",
            padding: "2px 25px",
            background: "white",

            "&:focused": {
              background: "white",
            },

            "&:hover": {
              background: "black",
              color: "white",
            },
          },
        },
        text: {
          borderRadius: "0",
          color: "black",
          backgroundColor: "transparent",
          position: "relative",

          "&::after": {
            content: '""',
            position: "absolute",
            width: "0",
            height: "2px",
            bottom: "0",
            left: "50%",
            backgroundColor: "black",
            transition: "width 0.15s ease 0s, left 0.15s ease 0s",
          },
          "&:hover": {
            backgroundColor: "transparent",
          },
          "@media (hover: hover) and (pointer: fine)": {
            "&:hover::after": {
              width: "100%",
              left: "0",
            },
          },
          "@media (hover: none) or (pointer: coarse)": {
            "&:active::after": {
              width: "100%",
              left: "0",
            },
            "&:focus::after": {
              width: "0",
              left: "50%",
            },
          },
        },
      },
      variants: [
        {
          props: { variant: "main" },
          style: {
            border: "1px solid black",
            borderRadius: "20px",
            color: "black",
            padding: "2px 25px",
            background: "white",

            "&:focused": {
              background: "white",
            },

            "&:hover": {
              background: "black",
              color: "white",
            },
          },
        },
        {
          props: { variant: "main-square" },
          style: {
            borderRadius: "4px",
            color: "white",
            padding: "2px 25px",
            background: "black",
            border: "1px solid transparent",

            "&:disabled": {
              background: "#cecece",
              color: "black",
            },

            "&:focused": {
              background: "white",
            },

            "&:hover": {
              background: "white",
              border: "1px solid black",
              color: "black",
            },
          },
        },
      ],
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          fill: "#fff",
        },
      },
    },
    MuiRadio: {
      variants: [
        {
          props: { variant: "pill" },
          style: {
            "& .MuiSvgIcon-root": {
              display: "none",
            },
            "& + .MuiFormControlLabel-label": {
              border: "1px solid",
              borderColor: "black",
              borderRadius: "9999px",
              padding: "6px 20px",
              transition: "all 0.2s",
              minWidth: "100px",
              textAlign: "center",
              fontSize: "18px",
            },
            "&.Mui-checked + .MuiFormControlLabel-label": {
              backgroundColor: "black",
              color: "white",
            },
            "& .MuiButtonBase": {
              display: "none",
            },
          },
        },
        {
          props: { variant: "round" },
          style: ({ theme }) => ({
            "& .MuiSvgIcon-root": {
              display: "none",
            },

            "& + .MuiFormControlLabel-label": {
              border: "1px solid",
              borderColor: "black",
              borderRadius: "9999px",
              padding: "30px",
              transition: "all 0.2s",
              minWidth: "74px",
              textAlign: "center",
              fontSize: "22px",
            },
            "&.Mui-checked + .MuiFormControlLabel-label": {
              backgroundColor: "black",
              color: "white",
            },
            "& .MuiButtonBase": {
              display: "none",
            },
          }),
        },
        {
          props: { variant: "round-outlined-small" },
          style: ({ theme }) => ({
            "& .MuiSvgIcon-root": {
              display: "none",
            },

            "& + .MuiFormControlLabel-label": {
              border: "1px solid",
              borderColor: "black",
              borderRadius: "10px",
              // padding: "40px",
              padding: "14px",
              transition: "all 0.2s",
              minWidth: "50px",
              textAlign: "center",
              fontSize: "12px",
            },
            "&.Mui-checked + .MuiFormControlLabel-label": {
              backgroundColor: "black",
              color: "white",
            },
            "& .MuiButtonBase": {
              display: "none",
            },
          }),
        },
        {
          props: { variant: "buttons" },
          style: ({ theme }) => ({
            "& .MuiSvgIcon-root": {
              display: "none",
            },

            "& + .MuiFormControlLabel-label": {
              width: "auto",
              height: "35px",
              background: "white",
              borderRadius: "6px",
              border: "1px solid #0ED28B",
              textAlign: "center",
              fontSize: "1rem",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              fontWeight: 500,
              minWidth: "31vw",
              [theme.breakpoints.up("sm")]: {
                minWidth: "200px",
              },
            },
            "&.Mui-checked + .MuiFormControlLabel-label": {
              backgroundColor: "#0ED28B",
              color: "black",
            },
            "& .MuiButtonBase": {
              display: "none",
            },
          }),
        },
        {
          props: { variant: "buttons-large" },
          style: ({ theme }) => ({
            "& .MuiSvgIcon-root": {
              display: "none",
            },

            "& + .MuiFormControlLabel-label": {
              width: "auto",
              height: "52px",
              background: "white",
              borderRadius: "6px",
              border: "1px solid #0ED28B",
              textAlign: "center",
              fontSize: "1rem",
              display: "flex",
              // flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              fontWeight: 500,
              padding: "0 32px",
              minWidth: "31vw",
              [theme.breakpoints.up("sm")]: {
                minWidth: "200px",
              },
            },
            "&.Mui-checked + .MuiFormControlLabel-label": {
              backgroundColor: "#0ED28B",
              color: "black",
            },
            "& .MuiButtonBase": {
              display: "none",
            },
          }),
        },
        {
          props: { variant: "large" },
          style: ({ theme }) => ({
            "& .MuiSvgIcon-root": {
              display: "none",
            },
            "& + .MuiFormControlLabel-label": {
              width: "100%",
              marginInlineEnd: "0",
              marginInlineStart: "0",
              border: "0",
              backgroundColor: "transparent",
              textAlign: "left",
              "& .MuiRadio-root": {
                display: "none",
              },
              border: "2px solid #0ED28B",
              height: "21.66vw",
              alignItems: "center",
              display: "flex",
              paddingLeft: "5.27vw",
              paddingRight: "6.48vw",

              [theme.breakpoints.up("sm")]: {
                height: "12vw",
                paddingLeft: "2vw",
                paddingRight: "1.5vw",
              },
            },
            "&.Mui-checked + .MuiFormControlLabel-label": {
              backgroundColor: "#0ED28B",
              color: "black",
            },
          }),
        },
        {
          props: { variant: "round-outlined" },
          style: ({ theme }) => ({
            "& .MuiSvgIcon-root": {
              display: "none",
            },

            "& + .MuiFormControlLabel-label": {
              border: "1px solid",
              borderColor: "black",
              borderRadius: "10px",
              // padding: "40px",
              padding: "20px",
              transition: "all 0.2s",
              minWidth: "74px",
              textAlign: "center",
              fontSize: "22px",
            },
            "&.Mui-checked + .MuiFormControlLabel-label": {
              backgroundColor: "black",
              color: "white",
            },
            "& .MuiButtonBase": {
              display: "none",
            },
          }),
        },
      ],
    },
    MuiTextField: {
      variants: [
        {
          props: { variant: "standard" },
          style: {
            "& .MuiInput-root.MuiInput-underline::before": {
              borderBottom: "2px solid #D5DDE5",
            },

            "& .MuiInput-root::before": {
              borderBottom: "2px solid #D5DDE5",
            },

            "&.MuiTextField-root .MuiFormLabel-root": {
              fontWeight: 800,
              fontSize: "22px",
              lineHeight: "20px",
              top: "-16px",
            },

            "& .MuiInputBase-input": {
              fontWeight: 800,
              fontSize: "22px",
              // lineHeight: "20px",
              top: "26px",
              color: `${whiteColor}`,
            },

            "& .MuiInputBase-input::placeholder": {
              fontWeight: 800,
              fontSize: "22px",
              lineHeight: "20px",
            },
          },
        },
        {
          props: { variant: "outlined" },
          style: {
            "& .MuiInputBase-root": {
              border: `1px solid ${darkTextColor}`,
            },

            "& .MuiInput-root.MuiInput-underline::before": {
              borderBottom: "2px solid #D5DDE5",
            },

            "& .MuiInput-root::before": {
              borderBottom: "2px solid #D5DDE5",
            },

            "&.MuiTextField-root .MuiFormLabel-root": {
              color: `${darkTextColor} !important`,
              background: `${darkBg}`,
              padding: "0 5px",
            },

            "& .MuiInputBase-input": {
              color: `${whiteColor}`,
            },

            "& .MuiInputBase-input::placeholder": {
              color: `${whiteColor}`,
            },

            "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
              {
                borderColor: `transparent`, // Keep the border color on focus if desired
              },

            "& .MuiOutlinedInput-root.Mui-focused": {
              outline: "none", // Remove the default blue focus outline
            },
          },
        },
      ],
    },
    MuiList: {
      styleOverrides: {
        root: {
          backgroundColor: `${darkBg} !important`,
        },
      },
    },
    MuiListItemText: {
      styleOverrides: {
        root: {
          padding: "10px",
          borderRadius: "6px",
          backgroundColor: `${darkTextColor} !important`,
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          paddingLeft: "0px !important",
        },
      },
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          backgroundColor: `${darkBg} !important`,
          borderRadius: "0",
          "&.Mui-expanded": {
            backgroundColor: `${darkBgAccent} !important`,
          },
        },
      },
    },
    MuiAccordionDetails: {
      styleOverrides: {
        root: {
          color: `${darkTextColor}`,
        },
      },
    },
  },
});

const theme = createTheme({
  palette: {
    primary: {
      main: "#00B86A",
    },
    secondary: {
      main: "#00B86A",
    },
    black: {
      main: "#000",
    },
    grey: {
      main: "#cecece",
    },
  },
  typography: {
    fontFamily: "inherit",
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 600,

    h1: {
      fontWeight: 700,
      fontSize: "2.125rem", // ~34px
      lineHeight: 1.2,
      marginBottom: "0.5rem",
      "@media (min-width:600px)": { fontSize: "2.5rem", lineHeight: 1.25 }, // 40px
    },
    h2: {
      fontWeight: 500,
      fontSize: "32px",
      marginBottom: "10px",
      lineHeight: "120%",
      "@media (max-width: 600px)": { fontSize: "30px" }, // 32px
    },
    h3: {
      fontWeight: 700,
      fontSize: "1.375rem", // ~22px
      lineHeight: 1.3,
      marginBottom: "0.5rem",
      "@media (min-width:600px)": { fontSize: "1.5rem", lineHeight: 1.35 }, // 24px
    },
    h4: {
      fontWeight: 600,
      fontSize: "1.25rem", // ~20px
      lineHeight: 1.35,
      marginBottom: "0.5rem",
      "@media (min-width:600px)": { fontSize: "1.375rem", lineHeight: 1.4 }, // 22px
    },
    h5: {
      fontWeight: 700,
      fontSize: "1.125rem", // ~18px
      lineHeight: 1.4,
      marginBottom: "0.5rem",
      "@media (min-width:600px)": { fontSize: "1.25rem", lineHeight: 1.45 }, // 20px
    },
    h6: {
      fontWeight: 400,
      fontSize: "20px", // ~16px
      lineHeight: "120%",
      marginBottom: "40px",
      "@media (max-width: 600px)": {
        fontSize: "18px",
        fontWeight: 400,
        marginBottom: "24px",
        lineHeight: "140%",
      },
    },

    h6_sm: {
      fontWeight: 400,
      fontSize: "20px", // ~16px
      lineHeight: "120%",
      marginBottom: "40px",
      "@media (max-width: 600px)": {
        fontSize: "14px",
        fontWeight: 400,
        marginBottom: "24px",
        lineHeight: "140%",
      },
    },

    inputLabel: {
      fontWeight: 500,
      fontSize: "20px",
      lineHeight: "120%",
      marginBottom: "10px",
      "@media (max-width: 600px)": {
        fontSize: "16px",
        fontWeight: 500,
        lineHeight: "120%",
      },
    },

    subtitle1: {
      fontWeight: 400,
      fontSize: "0.9375rem", // ~15px
      lineHeight: 1.56,
      marginBottom: "0.5rem",
    },
    subtitle2: {
      fontWeight: 400,
      fontSize: "0.875rem", // ~14px
      lineHeight: 1.5,
      marginBottom: "0.5rem",
    },

    body1: {
      fontWeight: 400,
      fontSize: "1rem", // ~17px (iOS) / 14px (macOS)
      lineHeight: 1.6,
      marginBottom: "0.5rem",
    },
    body2: {
      fontWeight: 500,
      fontSize: "0.9375rem", // ~16px
      lineHeight: 1.6,
      marginBottom: "0.5rem",
    },

    caption: {
      fontWeight: 400,
      fontSize: "0.75rem", // ~12px
      lineHeight: 1.6,
      marginBottom: "0.5rem",
    },
    overline: {
      fontWeight: 500,
      fontSize: "0.6875rem", // ~11px
      lineHeight: 1.5,
      marginBottom: "0.5rem",
      textTransform: "none",
    },

    button: {
      fontWeight: 600,
      fontSize: "0.9375rem", // ~16px
      lineHeight: 1.4,
      marginBottom: "0.5rem",
      textTransform: "none",
      letterSpacing: "0.02em",
    },

    p: {
      fontWeight: 300,
      color: "#000",
      fontSize: "14px",
      "@media (max-width: 600px)": {
        fontSize: "11px",
      },
      // lineHeight: 1.7,
      // marginBottom: "0.5rem",
    },
    p_label: {
      display: "flex",
      fontWeight: 400,
      textAlign: "left",
      color: "#000",
      fontSize: "20px",
      lineHeight: "120%",
      marginBottom: "10px",
      "@media (max-width: 600px)": {
        fontSize: "16px",
        marginBottom: "10px",
      },
      // lineHeight: 1.7,
      // marginBottom: "0.5rem",
    },
    p_attention: {
      fontWeight: 400,
      color: "#000",
      fontSize: "18px",
      lineHeight: "120%",
      background: "#E9F3EB",
      padding: "16px 10px",
      borderRadius: "12px",
      "@media (max-width: 600px)": {
        fontSize: "16px",
        padding: "16px",
      },
      // lineHeight: 1.7,
      // marginBottom: "0.5rem",
    },
    p_subtext: {
      fontWeight: 400,
      color: "#2C2C2C",
      fontSize: "18px",
      lineHeight: "120%",
      "@media (max-width: 600px)": {
        color: "#000",
        fontSize: "14px",
        lineHeight: "140%",
      },
    },
    p_subtext_sm: {
      fontWeight: 500,
      color: "#000 !important",
      fontSize: "16px !important",
      lineHeight: "120% !important",
      "@media (max-width: 600px)": {
        color: "#000 !important",
        fontSize: "12px !important",
        lineHeight: "140% !important",
        fontWeight: 400,
      },
    },
    p_subtext_sm_date: {
      fontWeight: 500,
      color: "#000 !important",
      fontSize: "16px !important",
      lineHeight: "120% !important",
      "@media (max-width: 600px)": {
        color: "#000 !important",
        fontSize: "16px !important",
        lineHeight: "140% !important",
        fontWeight: 400,
      },
    },
    attention: {
      color: `${warningTextColorLight} !important`,
      fontSize: "1rem !important", // ~17px (iOS) / 14px (macOS)
      textAlign: "justify",
      fontWeight: 600,
    },
    disclaimer: {
      fontSize: "14px",
      textAlign: "justify",
      color: `#2c2c2c`,
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: "white",
        },
      },
    },
    MuiContainer: {
      styleOverrides: {
        root: {
          padding: 0,
        },
      },
    },
    MuiTypography: {
      variants: [
        {
          props: { variant: "span" },
          style: {
            // fontSize: '1rem',
            // fontWeight: 400,
            // lineHeight: 1.5,
            // display: 'inline',
          },
        },
        {
          props: { variant: "heading" },
          style: {
            lineHeight: "46px",
            // maxWidth: "312px",
          },
        },
      ],
    },
    MuiTabs: {
      styleOverrides: {
        scroller: {
          borderRight: "none",
          padding: "20px",
          paddingBlockStart: 0,
          paddingInlineStart: "61px",
        },
        flexContainer: {
          borderLeft: "1px solid black",
          display: "flex",
          gap: "100px",
          height: "100%",
          paddingBlockStart: "40px",
        },
        indicator: {
          backgroundColor: "transparent",
          transform: "translateY(-10px)",
          left: "-5px",
          width: "50px",
          height: "50px",

          // "&::after": {
          //   content: '"\\1F693"',
          // },
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          // textTransform: "capitalize",
          fontWeight: 800,
          fontSize: "22px",
          alignItems: "flex-start",
          padding: "15px 24px",
          "&.Mui-selected": {
            color: "black",
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          backgroundColor: "#00B86A",
          color: "#FFFFFF",
          display: "flex",
          fontSize: `18.75px`,
          textTransform: "none",
          fontWeight: 700,
          marginBottom: "30px",
          zIndex: 1,
          "&:hover": {
            background: "#00B86A",
            color: "#FFFFFF",
          },
          "&:active": {
            background: "#00B86A",
            color: "#FFFFFF",
          },
          "&:focus": {
            background: "#00B86A",
            color: "#FFFFFF",
          },
          "&.primary-button": {
            border: "1px solid black",
            borderRadius: "20px",
            color: "black",
            padding: "2px 25px",
            background: "white",

            "&:focused": {
              background: "white",
            },

            "&:hover": {
              background: "black",
              color: "white",
            },
          },
        },
        text: {
          borderRadius: "0",
          color: "black",
          backgroundColor: "transparent",
          position: "relative",

          "&::after": {
            content: '""',
            position: "absolute",
            width: "0",
            height: "2px",
            bottom: "0",
            left: "50%",
            backgroundColor: "black",
            transition: "width 0.15s ease 0s, left 0.15s ease 0s",
          },
          "&:hover": {
            backgroundColor: "transparent",
          },
          "@media (hover: hover) and (pointer: fine)": {
            "&:hover::after": {
              width: "100%",
              left: "0",
            },
          },
          "@media (hover: none) or (pointer: coarse)": {
            "&:active::after": {
              width: "100%",
              left: "0",
            },
            "&:focus::after": {
              width: "0",
              left: "50%",
            },
          },
        },
      },
      variants: [
        {
          props: { variant: "main" },
          style: {
            border: "1px solid black",
            borderRadius: "20px",
            color: "black",
            padding: "2px 25px",
            background: "white",

            "&:focused": {
              background: "white",
            },

            "&:hover": {
              background: "black",
              color: "white",
            },
          },
        },
        {
          props: { variant: "main-square" },
          style: {
            borderRadius: "4px",
            color: "white",
            padding: "2px 25px",
            background: "black",
            border: "1px solid transparent",

            "&:disabled": {
              background: "#cecece",
              color: "black",
            },

            "&:focused": {
              background: "white",
            },

            "&:hover": {
              background: "white",
              border: "1px solid black",
              color: "black",
            },
          },
        },
      ],
    },
    MuiRadio: {
      variants: [
        {
          props: { variant: "pill" },
          style: {
            "& .MuiSvgIcon-root": {
              display: "none",
            },
            "& + .MuiFormControlLabel-label": {
              border: "1px solid",
              borderColor: "black",
              borderRadius: "9999px",
              padding: "6px 20px",
              transition: "all 0.2s",
              minWidth: "100px",
              textAlign: "center",
              fontSize: "18px",
            },
            "&.Mui-checked + .MuiFormControlLabel-label": {
              backgroundColor: "black",
              color: "white",
            },
            "& .MuiButtonBase": {
              display: "none",
            },
          },
        },
        {
          props: { variant: "round" },
          style: ({ theme }) => ({
            "& .MuiSvgIcon-root": {
              display: "none",
            },

            "& + .MuiFormControlLabel-label": {
              border: "1px solid",
              borderColor: "black",
              borderRadius: "9999px",
              padding: "30px",
              transition: "all 0.2s",
              minWidth: "74px",
              textAlign: "center",
              fontSize: "22px",
            },
            "&.Mui-checked + .MuiFormControlLabel-label": {
              backgroundColor: "black",
              color: "white",
            },
            "& .MuiButtonBase": {
              display: "none",
            },
          }),
        },
        {
          props: { variant: "round-outlined-small" },
          style: ({ theme }) => ({
            "& .MuiSvgIcon-root": {
              display: "none",
            },

            "& + .MuiFormControlLabel-label": {
              border: "1px solid",
              borderColor: "black",
              borderRadius: "10px",
              // padding: "40px",
              padding: "14px",
              transition: "all 0.2s",
              minWidth: "50px",
              textAlign: "center",
              fontSize: "12px",
            },
            "&.Mui-checked + .MuiFormControlLabel-label": {
              backgroundColor: "black",
              color: "white",
            },
            "& .MuiButtonBase": {
              display: "none",
            },
          }),
        },
        {
          props: { variant: "buttons" },
          style: ({ theme }) => ({
            "& .MuiSvgIcon-root": {
              display: "none",
            },

            "& + .MuiFormControlLabel-label": {
              width: "auto",
              height: "35px",
              background: "white",
              borderRadius: "6px",
              border: "1px solid #0ED28B",
              textAlign: "center",
              fontSize: "1rem",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              fontWeight: 500,
              minWidth: "31vw",
              [theme.breakpoints.up("sm")]: {
                minWidth: "200px",
              },
            },
            "&.Mui-checked + .MuiFormControlLabel-label": {
              backgroundColor: "#0ED28B",
              color: "black",
            },
            "& .MuiButtonBase": {
              display: "none",
            },
          }),
        },
        {
          props: { variant: "buttons-large" },
          style: ({ theme }) => ({
            "& .MuiSvgIcon-root": {
              display: "none",
            },

            "& + .MuiFormControlLabel-label": {
              width: "auto",
              height: "52px",
              background: "white",
              borderRadius: "6px",
              border: "1px solid #0ED28B",
              textAlign: "center",
              fontSize: "1rem",
              display: "flex",
              // flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              fontWeight: 500,
              padding: "0 32px",
              minWidth: "31vw",
              [theme.breakpoints.up("sm")]: {
                minWidth: "200px",
              },
            },
            "&.Mui-checked + .MuiFormControlLabel-label": {
              backgroundColor: "#0ED28B",
              color: "black",
            },
            "& .MuiButtonBase": {
              display: "none",
            },
          }),
        },
        {
          props: { variant: "large" },
          style: ({ theme }) => ({
            "& .MuiSvgIcon-root": {
              display: "none",
            },
            "& + .MuiFormControlLabel-label": {
              width: "100%",
              marginInlineEnd: "0",
              marginInlineStart: "0",
              border: "0",
              backgroundColor: "transparent",
              textAlign: "left",
              "& .MuiRadio-root": {
                display: "none",
              },
              border: "2px solid #0ED28B",
              height: "21.66vw",
              alignItems: "center",
              display: "flex",
              paddingLeft: "5.27vw",
              paddingRight: "6.48vw",

              [theme.breakpoints.up("sm")]: {
                height: "12vw",
                paddingLeft: "2vw",
                paddingRight: "1.5vw",
              },
            },
            "&.Mui-checked + .MuiFormControlLabel-label": {
              backgroundColor: "#0ED28B",
              color: "black",
            },
          }),
        },
        {
          props: { variant: "round-outlined" },
          style: ({ theme }) => ({
            "& .MuiSvgIcon-root": {
              display: "none",
            },

            "& + .MuiFormControlLabel-label": {
              border: "1px solid",
              borderColor: "black",
              borderRadius: "10px",
              // padding: "40px",
              padding: "20px",
              transition: "all 0.2s",
              minWidth: "74px",
              textAlign: "center",
              fontSize: "22px",
            },
            "&.Mui-checked + .MuiFormControlLabel-label": {
              backgroundColor: "black",
              color: "white",
            },
            "& .MuiButtonBase": {
              display: "none",
            },
          }),
        },
      ],
    },
    MuiTextField: {
      variants: [
        {
          props: { variant: "standard" },
          style: {
            "& .MuiInput-root.MuiInput-underline::before": {
              borderBottom: "2px solid #000",
            },

            "& .MuiInput-root::before": {
              borderBottom: "2px solid #000",
            },

            "&.MuiTextField-root .MuiFormLabel-root": {
              fontWeight: 800,
              fontSize: "22px",
              lineHeight: "20px",
              top: "-16px",
            },

            "& .MuiInputBase-input": {
              fontWeight: 800,
              fontSize: "22px",
              // lineHeight: "20px",
              top: "26px",
            },

            "& .MuiInputBase-input::placeholder": {
              fontWeight: 800,
              fontSize: "22px",
              lineHeight: "20px",
            },
          },
        },
      ],
    },
  },
});

export default theme;
